// extracted by mini-css-extract-plugin
export var editInput = "_f8-0";
export var editInputCompact = "_f8-2";
export var editInputLarge = "_f8-1";
export var editInputSmall = "_f8-3";